document.addEventListener('DOMContentLoaded', function () {
  const main = document.querySelector('main')
  if (!main || !main.classList.contains('news')) return

  const archive = main.querySelector('.js_news_archive')
  const tabButtons = main.querySelectorAll('.js_news_tab')
  const yearSelect = main.querySelector('.js_news_year')
  const result = main.querySelector('.js_news_result')
  const ajaxTitles = main.querySelectorAll('.js_ajax_title')

  if (!archive || !yearSelect || !result) return

  function setLoading(isLoading) {
    archive.classList.toggle('is-loading', isLoading)
  }

  function updateArchiveState({ term, year, paged }) {
    archive.dataset.term = term
    archive.dataset.year = year
    archive.dataset.paged = paged
  }

  function updateTabCurrent(term) {
    tabButtons.forEach((button) => {
      button.classList.toggle('is-current', button.dataset.term === term)
    })
  }

  function updateTitles(label) {
    ajaxTitles.forEach((el) => {
      el.textContent = label
    })
  }

  function scrollToNewsSection() {
    const section = main.querySelector('.sec02')
    if (!section) return

    const header = document.querySelector('header')
    const headerHeight = header ? header.offsetHeight : 0
    const top = window.pageYOffset + section.getBoundingClientRect().top - headerHeight

    window.scrollTo({
      top,
      behavior: 'smooth',
    })
  }

  async function fetchNews({ term, year = '', paged = 1 }) {
    const formData = new FormData()
    formData.append('action', newsAjax.action)
    formData.append('term', term)
    formData.append('year', year)
    formData.append('paged', paged)
    formData.append('lang', archive.dataset.lang || '')

    setLoading(true)

    try {
      const response = await fetch(newsAjax.ajax_url, {
        method: 'POST',
        body: formData,
      })

      const json = await response.json()

      if (!json.success || !json.data) {
        return
      }

      const data = json.data

      updateArchiveState({
        term: data.term,
        year: data.year,
        paged: paged,
      })

      updateTabCurrent(data.term)
      updateTitles(data.term_label)

      yearSelect.innerHTML = data.year_options
      result.innerHTML = data.list_html

      scrollToNewsSection()
    } catch (error) {
      console.error('News ajax error:', error)
    } finally {
      setLoading(false)
    }
  }

  tabButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const term = this.dataset.term
      if (!term) return

      fetchNews({
        term,
        year: '',
        paged: 1,
      })
    })
  })

  yearSelect.addEventListener('change', function () {
    fetchNews({
      term: archive.dataset.term,
      year: this.value,
      paged: 1,
    })
  })
})
